if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }


      // HC - Modifications for add on product - 09 December '22
      addOnProduct(response, addOnProducts){
        let items = addOnProducts.filter(addOn => addOn.checked).map(addOn =>{
          return {
            id:addOn.value,
            quantity:1
          }
        })
        console.log({items})
       let params = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items }),
        };
        return fetch("/cart/add.js", params)
          .then((res) => res.json())
          .then(({items}) => {
           return this.updateCart();
          });
      }
      updateCart(){
        let promises = this.cart.getSectionsToRender().map( section=> {
          return fetch(`${window.Shopify.routes.root}?sections=${section.id}`).then( res => res.json());
        })
        Promise.all(promises).then( result => {
          this.cart.getSectionsToRender().forEach((section,index) =>{
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            sectionElement.innerHTML = this.cart.getSectionInnerHTML(result[index][section.id], section.selector);
          })
          setTimeout(() => {
            this.cart.open();
          });
        })
      }
      // END - HC - Modifications for add on product - 09 December '22
  
        

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        /* HC adding addOn products 21 Dec '22 */
        let addOnProducts = [...document.querySelectorAll('[name="addOn"]')];
        let checkedAddOns = addOnProducts.filter(addOn => addOn.checked);
        /* END - HC adding addOn products 21 Dec '22 */

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // TK - Checking cart after update - 15 March '24 | [SC] - 3rd Jan 2025 - theme update
            fetch(window.Shopify.routes.root + 'cart.js')
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              // TK - Updating progress bar - 15 March '24 - theme update
              if (typeof updateFreeShippingBar === "function") {updateFreeShippingBar(parsedState.total_price);}
              // [SC] - custom tiered progess bar - theme update
              if (typeof updateFreeShippingBar_2 === "function") {updateFreeShippingBar_2(parsedState.original_total_price);}
              if (typeof updateFreeShippingBar_3 === "function") {updateFreeShippingBar_3(parsedState.original_total_price);}
            });

            // [SC] - cart reccomendations
            if (typeof initializeCartRecommendations === 'function') {
              initializeCartRecommendations();
            }
            

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } 

            // HC - Modifications for add on product - 09 December '22
            /* HC adding addOn products 21 Dec '22 */
            else if(checkedAddOns.length > 0){
               console.log('product with add on')
               this.addOnProduct(response,addOnProducts ); 
            }
            /* END - HC adding addOn products 21 Dec '22 */
              
            else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');

          // commented below and replaced with code following it - [SC] - 3rd Jan 2025 - theme update
          // this.submitButtonText.textContent = window.variantStrings.addToCart;
          // HC - Displaying backorder message - 03 Aug '23 - [SC] - 3rd Jan 2025 - theme update
          const preorderDisclaimer =  document.querySelector('.disclaimers .preorder');
          if (backorder == true ) {
            this.submitButtonText.textContent = 'backorder';
            if (typeof(preorderDisclaimer) != 'undefined' && preorderDisclaimer != null) {preorderDisclaimer.style.display = 'flex';}
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
            if (typeof(preorderDisclaimer) != 'undefined' && preorderDisclaimer != null) {preorderDisclaimer.style.display = 'none';}
          }
          
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
